import React from 'react';
import ReactPlayer from 'react-player';
import './VideoPlayer.scss';

const VideoPlayer = ({ url, title, onClose }) => {
  return (
    <div className="video-player-modal">
      <div className="video-player-content">
        <button className="close-btn" onClick={onClose} aria-label="닫기">
          ✕
        </button>
        <div className="video-wrapper">
          <ReactPlayer
            url={url}
            width="100%"
            height="100%"
            controls
            playing
            config={{
              youtube: {
                playerVars: {
                  autoplay: 1,
                  mute: 0,
                  rel: 0
                }
              }
            }}
          />
        </div>
        <div className="video-meta">
          <h3 className="video-title">{title}</h3>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;